import React, { memo } from "react";
//import Slider from "react-carousel-responsive";
//import "react-carousel-responsive/dist/styles.css";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../services/axiosInstance";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { set } from "react-ga";

function Banner() {
  const { getEndUser } = useSelector((state) => state.Coupon);

  var SquareBanner = getEndUser?.filter(function (el) {
    return el.banner_dimension === "300 * 250";
  });

  var VerticalBanner = getEndUser?.filter(function (el) {
    return el.banner_dimension === "120 * 600";
  });

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed:2000
  };

  return (
    <>
      <Slider SquareBanner={SquareBanner}{...settings}>
        {SquareBanner &&
          SquareBanner?.map((slide, i) => (
            <div
              key={i}
              data-background={slide?.image_upload}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {slide?.banner_dimension === "300 * 250" ? (
                <a href={slide?.redirect_url} target="_blank">
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={`${BASE_URL}/${slide?.image_upload}`}
                    alt=""
                  />
                </a>
              ) : null}
            </div>
          ))}
      </Slider>
      <br />
      <Slider
        VerticalBanner={VerticalBanner}
   {...settings}
      >
        {VerticalBanner &&
          VerticalBanner?.map((slide, i) => (
            <div
              key={i}
              data-background={slide?.image_upload}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {slide?.banner_dimension === "120 * 600" ? (
                <a href={slide?.redirect_url} target="_blank">
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={
                      slide?.image_url || `${BASE_URL}/${slide?.image_upload}`
                    }
                    alt=""
                  />
                </a>
              ) : null}
            </div>
          ))}
      </Slider>
    </>
  );
}

export default memo(Banner);
